import axios from 'axios';
import axiosRetry from 'axios-retry';
import cookies from 'react-cookies';

export const createApiInstance = ({ endpoint, prefixPath = '' }) => {
  const apiInstance = axios.create({
    baseURL: `${endpoint}${prefixPath}`,
    headers: {
      'Content-Type': 'application/json',
    },
    timeout: 60000,
  });

  // Apply axios-retry
  axiosRetry(apiInstance, {
    retries: 3,
    retryDelay: axiosRetry.exponentialDelay,
    retryCondition: (error) => {
      // Retry on network errors or 5xx server errors
      return axiosRetry.isNetworkError(error) || axiosRetry.isRetryableError(error);
    },
  });

  // Interceptor Request
  apiInstance.interceptors.request.use(
    (config) => {
      const token = cookies.load('access_token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  // Interceptor Response: Return the `data` field directly, which will be of type T
  apiInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error?.response?.status === 401) {
        // Handle unauthorized access, e.g., redirect to login
        cookies.remove('access_token', { path: '/' });
        cookies.remove('refresh_token', { path: '/' });
      }
      return Promise.reject(error?.response?.data);
    }
  );

  return apiInstance;
};
